export default "__VITE_ASSET__Ds7a0uCN__"